import { render, staticRenderFns } from "./TftEnd.vue?vue&type=template&id=5e79d348&"
import script from "./TftEnd.vue?vue&type=script&lang=js&"
export * from "./TftEnd.vue?vue&type=script&lang=js&"
import style0 from "./TftEnd.vue?vue&type=style&index=0&id=5e79d348&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports